exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dz-uploaded-file[data-v-3f139f8b]{cursor:default}.dz-uploaded-file .dz-filename[data-v-3f139f8b]{width:calc(100% - 155px)}.dz-uploaded-file .dz-size[data-v-3f139f8b]{bottom:10px;left:158px}.dz-uploaded-file .dz-remove[data-v-3f139f8b]{bottom:8px}", ""]);

// exports
